import { defineStore } from "pinia";
import productMixesApiDrive from "@/services/http/api-drive/panachages";
import { useMagasinStore } from './magasin';

export const StatusTypes = {
  PANACHAGES_REQUEST: 'PANACHAGES_REQUEST',
  PANACHAGES_SUCCESS: 'PANACHAGES_SUCCESS',
  PANACHAGES_ERROR: 'PANACHAGES_ERROR'
}

export const usePanachagesStore = defineStore({
  id: 'panachages',
  state: () => {
    return {
      panachages: null,
      status: null,
      isLoading: false
    }
  },
  actions: {
    panachagesRequest() {
      this.status = StatusTypes.PANACHAGES_REQUEST;
    },
    panachagesSuccess() {
      this.status = StatusTypes.PANACHAGES_SUCCESS;
    },
    panachagesError() {
      this.status = StatusTypes.PANACHAGES_ERROR;
    },
    setPanachages(panachages) {
      this.panachages = panachages;
    },
    resetPanachages() {
      this.status = null;
      this.panachages = null;
    },
    updateLoadingStatus(value) {
      this.isLoading = value;
    },
    async fetchPanachages(params) {
      const magasinStore = useMagasinStore();
      this.panachagesRequest();
      this.updateLoadingStatus(true);
      try {
        const response = await this.$apiDrive.use(productMixesApiDrive).productMixes(magasinStore.id, params.link);
        this.setPanachages({ list: response.data.attributes.product_list.data, title: params.title, article: params.article });
        this.panachagesSuccess();
      } catch (err) {
        this.panachagesError();
      } finally {
        this.updateLoadingStatus(false);
      }
    }
  },
  getters: {
  }
})
